package viewer

import common.dto.ElementType
import common.dto.elementClasses
import editor.structure.StructureElement
import kotlinx.browser.document
import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.div

object ViewerLabel {
    fun createLabel(elt: StructureElement) = document.body?.append {
        val family = elementClasses.entries.find { (_, elementTypes) -> elementTypes.contains(elt.type) }
        div {
            style = """
                position: absolute;
                top: 64px;
                left: 8px;
                right: 8px;
                z-index: 999;
                pointer-events: none;
                display: flex; 
                flex-direction: row; 
                justify-content: start;
            """.trimIndent()
            div {
                style = """
                    display: flex; 
                    flex-direction: column; 
                    align-items: center;
                    background: #ccc;
                    border-radius: 16px;
                    padding: 4px;
                    border-style: solid;
                    border-width: 1px; 
                    border-color: #aaa;
                    min-width: 200px;
                """.trimIndent()
                p {
                    style = "color: black; font-weight: bold;"
                    +(elt.type.longerName ?: elt.type.name)
                }
                div {
                    style = """
                        padding: 8px;
                        flex-direction: row;
                        display: flex;
                        gap: 0rem;
                        margin-inline: auto;
                    """.trimIndent()
                    family?.value?.forEach {
                        box(it, elt.type == it)
                    }
                }
            }
        }
    }

    fun DIV.box(type: ElementType, highlight: Boolean = false) {
        div {
            style = """
                ${if (highlight) "padding: 4px;" else "padding: 4px 0;"}
                ${if (highlight) "background: #fc0;" else ""}
                border-radius: 8px;
                font-weight: normal;
                flex: 1 1 0%;
                display: flex; 
                flex-direction: column; 
                justify-content: space-between; 
                align-items: center; 
            """.trimIndent()

            img {
                style = """
                    width: 4rem;
                    height: 4rem;
                """.trimIndent()
                src = "/viewer/icons/${type.name.lowercase()}.png"
            }
        }
    }
}